module.exports = __webpack_public_path__ + "static/humans_northlanders-bc9aed6e0674c96c84018bf196526821.png";